var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 40",
    role: "img",
    "aria-label": "Paris",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 40,
    rx: 8,
    fill: "#0033a0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 27,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#ffffff"
  }, "Paris")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParis);
export default __webpack_public_path__ + "static/media/paris.9ac4155f0e0f41b085d2b1372402fc3d.svg";
export { ForwardRef as ReactComponent };